import { apiPost } from '../hooks/apiCall';

const loginUser = (payload) => {
    return apiPost(`${process.env.REACT_APP_API_HOST}/api/user/login`, payload)
}

export {
    loginUser
}